<script setup>
import { cn } from "@/lib/utils"

const props = defineProps({
  variant: {
    type: String,
    default: "default",
    validator: (value) => ["default", "destructive"].includes(value),
  },
  class: {
    type: String,
    default: "",
  },
})
</script>

<template>
  <div
    :class="
      cn(
        'relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4',
        {
          'bg-destructive/15 text-destructive dark:bg-destructive/20 [&>svg]:text-destructive': variant === 'destructive',
          'bg-background text-foreground [&>svg]:text-foreground': variant === 'default',
        },
        props.class
      )
    "
  >
    <slot />
  </div>
</template> 